import { Doc } from 'ember';
import { isLiteralObject } from './obj_utils';



// Takes array, using each element as a key
// Each key is assigned the provided value in the resulting object
// Ex: ['a', 'b', 'c'], true => {a: true, b: true, c: true}
export const objFromStringArray = ( array: string[], value: any = true ) : Object =>
{
	const obj = Object.assign(
		{},
		...array.map((key) =>
			({ [key]: value })
		)
	);
	
	return obj;
}



// Takes array of documents, using each element's _id as a key
// Each key is assigned the provided value in the resulting object
// Ex: [{_id: 'a'}, {_id: 'b'}], true => {a: true, b: true}
export const objFromDocArray = ( array: Doc[], value: any = true ) : Object =>
{
	return objFromStringArray(array.map(x => x._id), value);
}



// Checks all key-value pairs in object, returning true once it finds one that's truthy
export const hasAtLeastOneTruthyValue = (obj: Object) =>
{
	return Object.values(obj).some(v => !!v);
}



// Returns a deeply cleaned version of input, removing any undefined key-value pairs,
// as well as any undefined array items. Numbers and strings are returned as is,
// while arrays and objects are handled recursively.
export const excludeUndefinedValues = (input: any) =>
{
	// If given an array, recursively call this function for each array item
	if(input instanceof Array)
	{
		return input.map(x => excludeUndefinedValues(x)).filter(x => (x !== undefined));
	}
	
	// If given an object, recursively call this function for each key-value pair
	if(isLiteralObject(input))
	{
		let new_obj = {};
		
		// Undefined key-value pairs won't be included in output
		Object.keys(input).forEach((key) =>
		{
			let value = input[key];
			
			if(value !== undefined)
			{
				new_obj[key] = excludeUndefinedValues(value);
			}
		});
		
		return new_obj;
	}
	
	// If input isn't an array or object, we'll return it as is
	return input;
};


